/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Amplify } from 'aws-amplify';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.amplifyAuthConfig.userPoolId,
      userPoolClientId: environment.amplifyAuthConfig.userPoolClientId,
      identityPoolId: environment.amplifyAuthConfig.identityPoolId,
      loginWith: {
        oauth: {
          domain: environment.amplifyAuthConfig.oauth.domain,
          scopes: environment.amplifyAuthConfig.oauth.scopes,
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: environment.amplifyAuthConfig.oauth.responseType as 'code' | 'token',
        },
      },
    },
  },
  API: {
    REST: {
      api: {
        endpoint: environment.apiBaseURL,
        region: environment.amplifyAuthConfig.region,
      },
    },
  },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
